var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import RouteIcon from './RouteIcon';
import { connect } from 'react-redux';
import CurrentTime from './CurrentTime';
import '@fontsource/fira-sans/300.css';
import '@fontsource/fira-sans/500.css';
import StopMarker from './StopMarker';
import StopsView from './StopsView';
import SingleStopView from './SingleStopView';
var VIEW_SWITCH_INTERVAL = 7000;
var MonitorDisplay = /** @class */ (function (_super) {
    __extends(MonitorDisplay, _super);
    function MonitorDisplay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { view: 'next-stop' };
        return _this;
    }
    MonitorDisplay.prototype.componentDidMount = function () {
        document.body.style.backgroundColor = 'black';
        this.setupTimer();
    };
    MonitorDisplay.prototype.componentWillUnmount = function () {
        document.body.style.backgroundColor = '';
        this.clearTimer();
    };
    MonitorDisplay.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.display.upcomingStops[0] !== this.props.display.upcomingStops[0]) {
            this.clearTimer();
            this.setupTimer();
            this.setState({ view: 'next-stop' });
        }
    };
    MonitorDisplay.prototype.render = function () {
        var _a = this.props, display = _a.display, stopRequest = _a.stopRequest, tripStatus = _a.tripStatus, trip = _a.trip;
        var view = this.state.view;
        if (!trip) {
            return 'NO TRIP';
        }
        var color = '#' + trip.routeColor;
        var textColor = '#' + trip.routeTextColor;
        return (React.createElement("div", { style: { fontFamily: 'Fira Sans', background: 'white' } },
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', padding: 24, gap: 24, background: '#EEEEEE' } },
                React.createElement(RouteIcon, { route: display.headsignRoute, color: color, textColor: textColor }),
                React.createElement("svg", { width: "40", height: "50", viewBox: "0 0 40 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { 
                        /* tslint:disable-next-line:max-line-length */
                        d: "M0 4.67406L0 45.3258C0 48.4257 3.43026 50.3092 6.07196 48.6219L38.1666 28.296C40.6111 26.7657 40.6111 23.2342 38.1666 21.6646L6.07196 1.37797C3.43026 -0.309318 0 1.57416 0 4.67406Z", fill: "#323232" })),
                React.createElement("div", { style: {
                        fontSize: 60,
                        fontWeight: 500,
                    } }, display.headsignText),
                React.createElement("div", { style: { flex: 1, textAlign: 'right', fontSize: 60, color: '#585858' } },
                    React.createElement(CurrentTime, null))),
            React.createElement("div", { style: { display: 'flex', height: 482, position: 'relative' } },
                stopRequest && (React.createElement(React.Fragment, null,
                    React.createElement(StopMarker, { position: "left" }),
                    React.createElement(StopMarker, { position: "right" }))),
                React.createElement("div", { style: { marginLeft: 216, marginRight: 216, marginTop: 48, display: 'flex', flex: 1 } }, view === 'next-stop' ? (React.createElement(SingleStopView, { color: color, display: display, tripStatus: tripStatus })) : (React.createElement(StopsView, { color: color, upcomingStops: display.upcomingStops }))))));
    };
    MonitorDisplay.prototype.setupTimer = function () {
        var _this = this;
        this.timer = setInterval(function () {
            _this.setState({ view: _this.state.view === 'next-stop' ? 'stops' : 'next-stop' });
        }, VIEW_SWITCH_INTERVAL);
    };
    MonitorDisplay.prototype.clearTimer = function () {
        clearInterval(this.timer);
    };
    return MonitorDisplay;
}(React.Component));
export default connect(function (_a) {
    var displays = _a.displays, stopRequest = _a.stopRequest, trip = _a.trip, tripStatus = _a.tripStatus;
    return ({ display: displays, stopRequest: stopRequest, trip: trip, tripStatus: tripStatus });
})(MonitorDisplay);



//////////////////
// WEBPACK FOOTER
// ./src/pages/MonitorDisplay/index.tsx
// module id = 1839
// module chunks = 0